import React from "react";
import { BankResponse } from "../service/bankService";
import { Button } from "@components/shadcn-ui/button";
import { Card, CardContent, CardHeader } from "@components/shadcn-ui/card";
import { Badge } from "@components/shadcn-ui/badge";
import { Edit, Trash2, CreditCard } from "lucide-react";

interface BankCardProps {
  bank: BankResponse;
  onDelete: (bankId: string) => void;
  onEdit: (bank: BankResponse) => void;
}

export const BankCard: React.FC<BankCardProps> = ({
  bank,
  onDelete,
  onEdit,
}) => {
  console.log("logging to avoid code refactoring", onDelete)
  const getAccountTypeColor = (type: string) => {
    switch (type) {
      case "SAVINGS":
        return "bg-green-100 text-green-800";
      case "CURRENT":
        return "bg-blue-100 text-blue-800";
      case "SALARY":
        return "bg-purple-100 text-purple-800";
      case "FIXED_DEPOSIT":
        return "bg-amber-100 text-amber-800";
      case "RECURRING_DEPOSIT":
        return "bg-indigo-100 text-indigo-800";
      case "NRE":
        return "bg-pink-100 text-pink-800";
      case "NRO":
        return "bg-teal-100 text-teal-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Mask account number to show only last 4 digits
  const maskAccountNumber = (accountNumber: string) => {
    if (!accountNumber) return "";
    const lastFour = accountNumber.slice(-4);
    const maskedPart = "X".repeat(accountNumber.length - 4);
    return maskedPart + lastFour;
  };

  return (
    <Card className="mb-4">
      <CardHeader className="pb-2 pt-4 px-4 flex flex-row justify-between items-center">
        <div className="flex items-center gap-2">
          <CreditCard className="h-4 w-4 text-gray-500" />
          <span className="font-medium">{bank.bankName}</span>
          <Badge className={getAccountTypeColor(bank.accountType)}>
            {bank.accountType}
          </Badge>
        </div>
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(bank)}
            className="h-8 w-8 p-0"
          >
            <Edit className="h-4 w-4" />
          </Button>
          {/*<Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(bank.id)}
            className="h-8 w-8 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
          </Button>*/}
        </div>
      </CardHeader>
      <CardContent className="px-4 py-2">
        <div className="text-sm">
          <div className="grid grid-cols-2 gap-2">
            <p className="text-gray-600">Account Number:</p>
            <p className="font-medium">{maskAccountNumber(bank.accountNumber)}</p>
            
            <p className="text-gray-600">IFSC Code:</p>
            <p>{bank.ifsc}</p>
            
            <p className="text-gray-600">Branch:</p>
            <p>{bank.branchName}</p>
            
            {bank.customerId && (
              <>
                <p className="text-gray-600">Customer ID:</p>
                <p>{bank.customerId}</p>
              </>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
